import { useRef} from 'react';
import { format, addDays, eachDayOfInterval, parse, isPast, isToday} from 'date-fns';
import { uk } from 'date-fns/locale';

export const DaysSelect = ({props, setCurrentDate}) => {
    
    const {schedule} = props;

    const dayRef = useRef(null);

    const now = new Date();
    
    const end = addDays(now, 3);
    
    const daysRange = eachDayOfInterval({
    start: now,
    end: end
    })

    const daysOptions = daysRange.map((day, index) => {
        const optionTitle = format(day, 'eeee', {locale: uk});
        const optionValue = format(day, 'dd-MM-yyyy', {locale: uk});

        const workHours = schedule().find(hour => hour.hasOwnProperty(optionTitle));

        if (workHours && isToday(day)) {
            const closeTime = parse(workHours[optionTitle].end, 'HH:mm', new Date());
            if (isPast(closeTime)) {
                return null
            }
        }

        return (
            <option key={index} value={optionValue}>{optionTitle.charAt(0).toUpperCase() + optionTitle.slice(1)}</option>
        )
    }).filter(Boolean);

    const handleDayChange = () => {
        const selectedIndex = dayRef.current.selectedIndex;
        const selectedDay = dayRef.current[selectedIndex].value;
        setCurrentDate(selectedDay);
    }

    return (
        <div className="col-auto">
        <label  className="form-label fs-6 fw-bold">Оберіть день</label>
        <select className="form-select fw-bold"
            defaultValue={`today`} 
            ref={dayRef}
            onChange={handleDayChange}
            name='ship-day'
            required
        >
            <option value="today" disabled>Оберіть день</option>
            {daysOptions}
        </select>
    </div>
    )
}